<template>
  <runtime-template-compiler class="" :template="html" v-if="rendered" style="height: 100%;">

  </runtime-template-compiler>

</template>

<script>
import WidgetMixin from './WidgetMixin';
import VRuntimeTemplate from 'v-runtime-template'
export default {
name: "BookingDetailOverview",
  mixins:[WidgetMixin],
  components:{VRuntimeTemplate},
  computed:{
    getEventItemIcon(){
      var css=[]
      if(this.eventDetail && this.eventDetail.eventItemType && this.eventDetail.eventItemType.key_icon){
        css.push("fal "+this.eventDetail.eventItemType.key_icon.icon)
      }else{
        css.push("fas fa-circle-notch fa-spin")
      }

      return css
    },
  },

  data(){
    return{
      currentTab:'description',
      showDetailModal:false,
      eventDetail: null,
      eventItemTime: null,
      eventItemType: null,
      loadingDetails:false,
      textfield: null,
      textfield2: null,
      textfield3: null,
      textfield4: null,
      textfield5: null,
      textfield6: null,
      textfield7: null,

    }
  },

  methods:{
    getDetailItem(url,eventItemTime,eventItemType){

      this.showDetailModal=true
      this.eventDetail=null
      this.eventItemTime=eventItemTime
      this.eventItemType=eventItemType
      axios.get(url)
          .then((response) => {
            //  console.log(response.data)
            console.log("[SCHEDULE]Finding Position in index");

            Vue.set(this, "eventDetail", response.data);


            Vue.nextTick().then(() => {
              this.loadingDetails = false;
              console.log("[POSTER] Latex Queue")
              setTimeout(()=>{
                //   MathJax.Hub.Queue(["Typeset",MathJax.Hub]);
              },200)
            });
          })
          .catch((error) => {
            console.log(error);

          });
    },
  }
}
</script>

<style lang="scss" >
.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(194,188,188, 0.2);
  border-right: 1.1em solid rgba(194,188,188, 0.2);
  border-bottom: 1.1em solid rgba(194,188,188, 0.2);
  border-left: 1.1em solid #c2bcbc;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}


.tab-enter-active,
.tab-leave-active,
.tab-move {

  transition: 500ms ease-in-out;
  transition-property: all;
}

.tab-enter {
  opacity: 0;
  transform: translateY(50px) scaleX(0.1);
}

.tab-enter-to {
  opacity: 1;
  transform:  scale(1);
}

.tab-leave-active {
  position: absolute;
}

.tab-leave-to {
  opacity: 0;
  transform: translateY(-50px) scaleX(0);
  transform-origin: center top;
}


.fade-enter-active,
.fade-leave-active {
  & > * {
    transition-duration: 200ms;
    transition-property: opacity, transform;
    transition-timing-function: cubic-bezier(.6,.15,.35,.8);
  }

}

$delay: 100ms;
$delayStep: 100ms;


                   .loader,
                   .loader:after {
                     border-radius: 50%;
                     width: 10em;
                     height: 10em;
                   }
.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(194,188,188, 0.2);
  border-right: 1.1em solid rgba(194,188,188, 0.2);
  border-bottom: 1.1em solid rgba(194,188,188, 0.2);
  border-left: 1.1em solid #c2bcbc;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}


.tab-enter-active,
.tab-leave-active,
.tab-move {

  transition: 500ms ease-in-out;
  transition-property: all;
}

.tab-enter {
  opacity: 0;
  transform: translateY(50px) scaleX(0.1);
}

.tab-enter-to {
  opacity: 1;
  transform:  scale(1);
}

.tab-leave-active {
  position: absolute;
}

.tab-leave-to {
  opacity: 0;
  transform: translateY(-50px) scaleX(0);
  transform-origin: center top;
}


.fade-enter-active,
.fade-leave-active {
  & > * {
    transition-duration: 200ms;
    transition-property: opacity, transform;
    transition-timing-function: cubic-bezier(.6,.15,.35,.8);
  }

}

$delay: 100ms;
$delayStep: 100ms;

.fade-enter,
.fade-leave-to {
  & > * {
    opacity: 0;
    transform: translateY(40px);
  }
}
.fade-enter-active {
  & > * {
    &:nth-child(2) {
      transition-delay: $delay;
    }
    &:nth-child(3) {
      transition-delay: $delay + $delayStep;
    }
  }
}
.fade-leave-active {
  & > * {
    &:nth-child(1) {
      transition-delay: $delay + $delayStep;
    }
    &:nth-child(2) {
      transition-delay: $delay;
    }
  }
}
</style>